import classNames from 'classnames';
import { ReactNode } from 'react';

import CloseIcon from '../icons/Close';
import Button from './Button';

import styles from '../../../styles/buttons/toggle-button.module.css';

interface ToggleButtonProps {
    opened?: boolean;
    withLabel?: boolean;
    onClick?: () => void;
    children?: ReactNode;
    className?: string;
}

function ToggleButton({
    opened = false,
    withLabel = false,
    onClick,
    children = null,
    className,
}: ToggleButtonProps) {
    return (
        <Button
            className={classNames([
                styles.container,
                className,
                {
                    [styles.opened]: opened && !withLabel,
                },
            ])}
            onClick={onClick}
        >
            <CloseIcon className={styles.closeIcon} />
            {children !== null ? <span className={styles.togglerLabel}>{children}</span> : null}
        </Button>
    );
}

export default ToggleButton;
